<template>
  <div>
    <v-data-table
    :headers="locoHeaders"
    :items="data"
    class="elevation-1 dp"
    hide-default-header
    :loading="loading"
    :loading-text="$t('message.loadingText', { value: 'default' })"
  >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="cursor: pointer" v-for="item in headers" :key="item.value">
            {{ item.text }}
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:[`item.sms`]="{ item }">
      <v-switch
        inset
        color="#EEBB07"
        v-model="item.sms"
        dense
        :readonly="activeSms()"
        hide-details
        class="mt-0"
        @click="updateAlert(item, 'sms')"
      ></v-switch>
    </template>
    <template v-slot:[`item.mail`]="{ item }">
      <v-switch
        inset
        color="#EEBB07"
        v-model="item.mail"
        dense
        hide-details
        class="mt-0"
        @click="updateAlert(item, 'mail')"
      ></v-switch>
    </template>
  </v-data-table>
    <div class="disclamer">
                            * {{ $t("message.alert.disclamer", { value: "default" }) }}
                        </div>
  </div>
  
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { arraySerialFilter, formatPhoneNumber } from "@/shared/ArrayHelper.js";
import { currentDate } from "@/shared/DateHelper";
import CascService from "@/services/CascService.js";

export default {
  watch: {
    getterCurrentClient() {
      this.loadLocomotive();
      this.loadContracts(this.getterCurrentClient);
    },
    $route(to) {
      this.loadAlert(to.fullPath);
    },

    "$i18n.locale": function () {
      this.locoHeaders() 
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      alertType: "battery",
      headers: [],
      alertList: [],
      queries: [],
    };
  },
  methods: {
    ...mapActions("customer", {
      loadLocos: "loadLocos",
      loadContracts: "loadContrats",
    }),

    async loadLocomotive() {
      let payload = {
        customer: this.getterCurrentClient,
        start: currentDate(),
        end: currentDate(),
      };
      await this.loadLocos(payload);
      this.headers = this.locoHeaders;
      this.loadAlert(this.$route.path);
    },

    updateAlert(item, target) {
      if (this.alertType == "battery") {
        if (target == "sms") {
          if (item.sms) {
            CascService.saveBatteryAlert(this.buildQueryObject(item, target));
          } else {
            CascService.deleteBatteryAlert(this.buildQueryObject(item, target));
          }
        } else {
          if (item.mail) {
            CascService.saveBatteryAlert(this.buildQueryObject(item, target));
          } else {
            CascService.deleteBatteryAlert(this.buildQueryObject(item, target));
          }
        }
      }

      if (this.alertType == "poi") {
        if (target == "sms") {
          if (item.sms) {
            CascService.savePoiAlert(this.buildQueryObject(item, target));
          } else {
            CascService.deletePoiAlert(this.buildQueryObject(item, target));
          }
        } else {
          if (item.mail) {
            CascService.savePoiAlert(this.buildQueryObject(item, target));
          } else {
            CascService.deletePoiAlert(this.buildQueryObject(item, target));
          }
        }
      }
    },
    filterContratAlert() {
      let finalList = [];
      let i = 0;
      for (i = 0; i < this.getterContrats.length; i++) {
        finalList.push({
          contrat: this.getterContrats[i],
          mail: false,
          sms: false,
        });
      }
      return finalList;
    },

    filterLocoAlert() {
      let finalList = [];
      let i = 0;

      for (i = 0; i < this.getterLocos.length; i++) {
        let mail = false;
        let sms = false;
        let findmail = this.alertList.find(
          (e) =>
            e.locomotive == this.getterLocos[i].loconum &&
            e.target.includes(this.getterContact.mail)
        );

        let findsms = this.alertList.find(
          (e) =>
            e.locomotive == this.getterLocos[i].loconum &&
            e.target.includes(formatPhoneNumber(this.getterContact.phone))
        );
        if (findmail !== undefined) {
          mail = true;
        }

        if (findsms !== undefined) {
          sms = true;
        }
        finalList.push({
          loconum: this.getterLocos[i].loconum,
          mail: mail,
          sms: sms,
        });
      }
      return finalList;
    },

    filterSerialAlert() {
      let finalList = [];
      let serialList = arraySerialFilter(this.getterLocos);

      let i = 0;
      for (i = 0; i < serialList.length; i++) {
        finalList.push({
          serial: serialList[i].serial,
          mail: false,
          sms: false,
        });
      }
      return finalList;
    },

    buildQueryObject(item, target) {
      let queryObject = {
        locomotives: [item.loconum],
        targets: [],
      };
      if (target == "mail") {
        queryObject.targets.push("mailto:" + this.getterContact.mail);
      }

      if (target == "sms") {
        queryObject.targets.push(
          "sms:" + formatPhoneNumber(this.getterContact.phone)
        );
      }
      return queryObject;
    },

    buildLocString() {
      return this.getterLocos.reduce(
        (prev, next) => prev + next.loconum + ",",
        ""
      );
    },

    activeSms(){
      if(this.getterContact.phone != null){
        return false
      }
      return true
    },

    buildQueryParam() {
      let paramString =
        "targets=mailto:" +
        this.getterContact.mail +
        ",sms:" +
        formatPhoneNumber(this.getterContact.phone);
      paramString += "&locomotives=" + this.buildLocString();
      return paramString;
    },

    loadAlert(path) {
      this.data= []
      if (path.includes("battery")) {
        this.alertType = "battery";
        CascService.loadBatteryAlert(this.buildQueryParam()).then(
          (response) => {
            this.alertList = response.data;
            this.data = this.filterLocoAlert();
            this.headers = this.locoHeaders;
            this.loading = false
          }
        );
      }

      if (path.includes("poi")) {
        this.alertType = "poi";
        CascService.loadPoiAlert(this.buildQueryParam()).then(
          (response) => {
            this.alertList = response.data;
            this.data = this.filterLocoAlert();
            this.headers = this.locoHeaders;
          }
        );
      }
    },
  },
  mounted() {
    this.getterLocos;
    this.loadContracts(this.getterCurrentClient);
    this.loadAlert(this.$route.path);
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
    ...mapGetters("customer", {
      getterLocos: "getFilterLoc",
      getterContrats: "getContrats",
    }),
    locoHeaders() {
      return [
        {
          text: this.$t("message.page.loconumber", { value: "default" }),
          align: "start",
          sortable: true,
          value: "loconum",
        },
        {
          text: this.$t("message.alert.mail", { value: "default" }),
          sortable: true,
          value: "mail",
        },
        {
          text: this.$t("message.alert.sms", { value: "default" }),
          sortable: true,
          value: "sms",
        }
      ];
    },
    serialHeaders() {
      return [
        {
          text: this.$t("message.page.serial", { value: "default" }),
          align: "start",
          sortable: true,
          value: "serial",
        },
        {
          text: this.$t("message.alert.mail", { value: "default" }),
          sortable: true,
          value: "mail",
        },
        {
          text: this.$t("message.alert.sms", { value: "default" }),
          sortable: true,
          value: "sms",
        },
      ];
    },
  },
};
</script>

<style scoped>
.dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: #fff;
  font-size: 16px;
}

.theme--light.v-icon {
  color: #fff;
}

.dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:hover {
  color: #fff;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
</style>